import React, { useEffect, useState } from "react";
import {
  Form,
  Card,
  Col,
  Row,
  Table,
  InputGroup,
  Button,
} from "react-bootstrap";
import Pic from "../../../assets/images/icons/user.png";
import { userTransactions } from "../../../utils/api";

function PaymentHistoryPage() {
  const [transactions, setTransactions] = useState([]);
  const [startDate, setStartDate] = useState("");
  const [endDate, setEndDate] = useState("");
  const [currentPage, setCurrentPage] = useState(1);
  const itemsPerPage = 10; // Show 10 records per page

  useEffect(() => {
    getTransactionDetails(startDate, endDate);
  }, []);

  const getTransactionDetails = async () => {
    try {
      const userTransaction = await userTransactions({
        start_date: startDate,
        end_date: endDate,
      });
      setTransactions(userTransaction?.data?.data || []);
      console.log("userTransaction", userTransaction);
    } catch (error) {
      console.error("Error fetching transactions:", error);
    }
  };

  useEffect(() => {
    if (startDate && endDate) {
      getTransactionDetails(startDate, endDate);
    }
  }, [startDate, endDate]);

  // **Pagination Logic**
  const indexOfLastItem = currentPage * itemsPerPage;
  const indexOfFirstItem = indexOfLastItem - itemsPerPage;
  const currentTransactions = transactions.slice(
    indexOfFirstItem,
    indexOfLastItem
  );
  const totalPages = Math.ceil(transactions.length / itemsPerPage);

  return (
    <>
      <Form>
        <Row className="mb-3 justify-content-between g-3">
          <Col md="5">
            <h1 className="text-[30px] font-semibold">Payments</h1>
          </Col>
          <Col md="6">
            <div>
              <Form.Group controlId="exampleForm.ControlInput1">
                <InputGroup>
                  <Form.Control
                    className="fs-14"
                    type="date"
                    value={startDate}
                    onChange={(e) => setStartDate(e.target.value)}
                  />
                  <InputGroup.Text>to</InputGroup.Text>
                  <Form.Control
                    className="fs-14"
                    type="date"
                    value={endDate}
                    onChange={(e) => setEndDate(e.target.value)}
                  />
                </InputGroup>
              </Form.Group>
            </div>
          </Col>
        </Row>
      </Form>

      <Card className="p-3 white_bg">
        <Table className="mt-2 align-middle borderless_td">
          <thead>
            <tr>
              <th>Program</th>
              <th>Coach</th>
              <th className="text-center">Amount</th>
              <th className="text-center">Status</th>
            </tr>
          </thead>
          <tbody>
            {currentTransactions.length > 0 ? (
              currentTransactions.map((transaction, index) => (
                <tr key={index}>
                  <td>
                    <p className="m-0 fs-10 fw-400 brand_text_color7">
                      #{transaction.id}
                    </p>
                    <h5 className="fs-12 fw-500 text_brand_color7">
                      {transaction.session_title || "No Title"} <br />
                    </h5>
                  </td>
                  <td>
                    <div className="d-flex align-items-center pic_labels sm">
                      <div className="">
                        <img
                          src={`${
                            process.env.REACT_APP_COACH_PROFILE_FOLDER_PATH
                          }${transaction.profile_pic || Pic}`}
                          className="w-[2.5rem] border h-[2.5rem] rounded-full object-cover"
                          alt="Coach"
                        />
                      </div>
                      <div className="flex-1 ms-1">
                        <div className="d-flex justify-content-between align-items-center">
                          <div>
                            <h5 className="m-0 text-black fs-14 fw-500">
                              {transaction.name || "Unknown Coach"}
                            </h5>
                            {transaction.professions &&
                              transaction.professions
                                .split(",")
                                .map((prof, i) => (
                                  <label key={i} className="fs-8">
                                    {prof.trim()}
                                  </label>
                                ))}
                          </div>
                        </div>
                      </div>
                    </div>
                  </td>
                  <td className="text-center">
                    <h5 className="fs-16 fw-600">
                      ${transaction.total_payment || "0"}
                    </h5>
                    <h6 className="fs-12 fw-500">
                      {transaction.created_at
                        ? new Date(transaction.created_at).toLocaleDateString()
                        : "N/A"}
                    </h6>
                  </td>
                  <td
                    className="text-center fs-12 fw-500 text"
                    style={{ color: "#139337" }}
                  >
                    {transaction.transaction_status || "Pending"}
                  </td>
                </tr>
              ))
            ) : (
              <tr>
                <td colSpan="4" className="text-center">
                  No Data Found
                </td>
              </tr>
            )}
          </tbody>
        </Table>

        {/* Pagination Controls */}
        {transactions.length > 10 && (
          <div className="mt-3 d-flex justify-content-center">
            <Button
              variant="outline-primary"
              onClick={() => setCurrentPage((prev) => Math.max(prev - 1, 1))}
              disabled={currentPage === 1}
              className="me-2"
            >
              Previous
            </Button>
            <span className="align-self-center">{`Page ${currentPage} of ${totalPages}`}</span>
            <Button
              variant="outline-primary"
              onClick={() =>
                setCurrentPage((prev) => Math.min(prev + 1, totalPages))
              }
              disabled={currentPage === totalPages}
              className="ms-2"
            >
              Next
            </Button>
          </div>
        )}
      </Card>
    </>
  );
}

export default PaymentHistoryPage;

{
  /* <tr>
                            <td>
                                <p className="m-0 fs-10 fw-400 brand_text_color7">#EICC2542</p>
                                <h5 className="fs-12 fw-500 text_brand_color7">Emotional Intelligence <br/> complete course</h5>
                            </td>
                            <td>
                                <div class="d-flex align-items-center pic_labels sm">
                                    <div class="pic_labels_img">
                                        <img src={Pic} alt="" />
                                    </div>
                                    <div class="ms-1 w-100">
                                        <div class="d-flex justify-content-between align-items-center">
                                            <div>
                                                <h5 class="text-black fs-14 fw-500 m-0">Jacob Jones </h5>
                                                <label className="fs-8">Project Manager</label>
                                                <label className="fs-8">IT Recruiter</label>
                                                <label className="fs-8">Career</label>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </td>
                            <td className="text-center">
                                <h5 className="fs-16 fw-600">$105</h5>
                                <h6 className="fs-12 fw-500">24-04-2024</h6>
                            </td>
                            <td className="text-center fs-12 fw-500 text" style={{color: '#139337'}}>Completed</td>
                        </tr>
                        <tr>
                            <td>
                                <p className="m-0 fs-10 fw-400 brand_text_color7">#EICC2542</p>
                                <h5 className="fs-12 fw-500 text_brand_color7">Emotional Intelligence <br/> complete course</h5>
                            </td>
                            <td>
                                <div class="d-flex align-items-center pic_labels sm">
                                    <div class="pic_labels_img">
                                        <img src={Pic} alt="" />
                                    </div>
                                    <div class="ms-1 w-100">
                                        <div class="d-flex justify-content-between align-items-center">
                                            <div>
                                                <h5 class="text-black fs-14 fw-500 m-0">Jacob Jones </h5>
                                                <label className="fs-8">Project Manager</label>
                                                <label className="fs-8">IT Recruiter</label>
                                                <label className="fs-8">Career</label>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </td>
                            <td className="text-center">
                                <h5 className="fs-16 fw-600">$105</h5>
                                <h6 className="fs-12 fw-500">24-04-2024</h6>
                            </td>
                            <td className="text-center fs-12 fw-500 text" style={{color: '#139337'}}>Completed</td>
                        </tr>
                        <tr>
                            <td>
                                <p className="m-0 fs-10 fw-400 brand_text_color7">#EICC2542</p>
                                <h5 className="fs-12 fw-500 text_brand_color7">Emotional Intelligence <br/> complete course</h5>
                            </td>
                            <td>
                                <div class="d-flex align-items-center pic_labels sm">
                                    <div class="pic_labels_img">
                                        <img src={Pic} alt="" />
                                    </div>
                                    <div class="ms-1 w-100">
                                        <div class="d-flex justify-content-between align-items-center">
                                            <div>
                                                <h5 class="text-black fs-14 fw-500 m-0">Jacob Jones </h5>
                                                <label className="fs-8">Project Manager</label>
                                                <label className="fs-8">IT Recruiter</label>
                                                <label className="fs-8">Career</label>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </td>
                            <td className="text-center">
                                <h5 className="fs-16 fw-600">$105</h5>
                                <h6 className="fs-12 fw-500">24-04-2024</h6>
                            </td>
                            <td className="text-center fs-12 fw-500 text" style={{color: '#139337'}}>Completed</td>
                        </tr>
                        <tr>
                            <td>
                                <p className="m-0 fs-10 fw-400 brand_text_color7">#EICC2542</p>
                                <h5 className="fs-12 fw-500 text_brand_color7">Emotional Intelligence <br/> complete course</h5>
                            </td>
                            <td>
                                <div class="d-flex align-items-center pic_labels sm">
                                    <div class="pic_labels_img">
                                        <img src={Pic} alt="" />
                                    </div>
                                    <div class="ms-1 w-100">
                                        <div class="d-flex justify-content-between align-items-center">
                                            <div>
                                                <h5 class="text-black fs-14 fw-500 m-0">Jacob Jones </h5>
                                                <label className="fs-8">Project Manager</label>
                                                <label className="fs-8">IT Recruiter</label>
                                                <label className="fs-8">Career</label>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </td>
                            <td className="text-center">
                                <h5 className="fs-16 fw-600">$105</h5>
                                <h6 className="fs-12 fw-500">24-04-2024</h6>
                            </td>
                            <td className="text-center fs-12 fw-500 text" style={{color: '#139337'}}>Completed</td>
                        </tr>
                        <tr>
                            <td>
                                <p className="m-0 fs-10 fw-400 brand_text_color7">#EICC2542</p>
                                <h5 className="fs-12 fw-500 text_brand_color7">Emotional Intelligence <br/> complete course</h5>
                            </td>
                            <td>
                                <div class="d-flex align-items-center pic_labels sm">
                                    <div class="pic_labels_img">
                                        <img src={Pic} alt="" />
                                    </div>
                                    <div class="ms-1 w-100">
                                        <div class="d-flex justify-content-between align-items-center">
                                            <div>
                                                <h5 class="text-black fs-14 fw-500 m-0">Jacob Jones </h5>
                                                <label className="fs-8">Project Manager</label>
                                                <label className="fs-8">IT Recruiter</label>
                                                <label className="fs-8">Career</label>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </td>
                            <td className="text-center">
                                <h5 className="fs-16 fw-600">$105</h5>
                                <h6 className="fs-12 fw-500">24-04-2024</h6>
                            </td>
                            <td className="text-center fs-12 fw-500 text" style={{color: '#139337'}}>Completed</td>
                        </tr>
                        <tr>
                            <td>
                                <p className="m-0 fs-10 fw-400 brand_text_color7">#EICC2542</p>
                                <h5 className="fs-12 fw-500 text_brand_color7">Emotional Intelligence <br/> complete course</h5>
                            </td>
                            <td>
                                <div class="d-flex align-items-center pic_labels sm">
                                    <div class="pic_labels_img">
                                        <img src={Pic} alt="" />
                                    </div>
                                    <div class="ms-1 w-100">
                                        <div class="d-flex justify-content-between align-items-center">
                                            <div>
                                                <h5 class="text-black fs-14 fw-500 m-0">Jacob Jones </h5>
                                                <label className="fs-8">Project Manager</label>
                                                <label className="fs-8">IT Recruiter</label>
                                                <label className="fs-8">Career</label>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </td>
                            <td className="text-center">
                                <h5 className="fs-16 fw-600">$105</h5>
                                <h6 className="fs-12 fw-500">24-04-2024</h6>
                            </td>
                            <td className="text-center fs-12 fw-500 text" style={{color: '#139337'}}>Completed</td>
                        </tr>
                        <tr>
                            <td>
                                <p className="m-0 fs-10 fw-400 brand_text_color7">#EICC2542</p>
                                <h5 className="fs-12 fw-500 text_brand_color7">Emotional Intelligence <br/> complete course</h5>
                            </td>
                            <td>
                                <div class="d-flex align-items-center pic_labels sm">
                                    <div class="pic_labels_img">
                                        <img src={Pic} alt="" />
                                    </div>
                                    <div class="ms-1 w-100">
                                        <div class="d-flex justify-content-between align-items-center">
                                            <div>
                                                <h5 class="text-black fs-14 fw-500 m-0">Jacob Jones </h5>
                                                <label className="fs-8">Project Manager</label>
                                                <label className="fs-8">IT Recruiter</label>
                                                <label className="fs-8">Career</label>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </td>
                            <td className="text-center">
                                <h5 className="fs-16 fw-600">$105</h5>
                                <h6 className="fs-12 fw-500">24-04-2024</h6>
                            </td>
                            <td className="text-center fs-12 fw-500 text" style={{color: '#139337'}}>Completed</td>
                        </tr> */
}
